import Comorbidades from '../pages/Comorbidades/Comorbidades'
import ComorbidadesPorEquipe from '../pages/Comorbidades/PorEquipe'
import ComorbidadesPorEquipeAcs from '../pages/Comorbidades/PorEquipeAcs'

export default [
  {
    path: '/comorbidades',
    component: () => import('@/pages/Comorbidades/Template.vue'),
    children: [
      {
        path: '/comorbidades',
        component: Comorbidades,
      },
      {
        path: '/comorbidades/equipe/acs',
        component: ComorbidadesPorEquipeAcs,
      },
      {
        path: '/comorbidades/equipe',
        component: ComorbidadesPorEquipe,
      },
    ],
  },
]
